module.exports = __webpack_public_path__ + "img/sos.91e6c8cd.jpeg";